import NoPage from "./noPage";

export default NoPage;